export interface TintedLayer {
    src: string;
    tint?: string;
}

const POTION_BOTTLES: Record<string, string> = {
    'minecraft:potion': '/mc/potion_bottle_drinkable.png',
    'minecraft:splash_potion': '/mc/potion_bottle_splash.png',
};

export function itemSpriteSrc(itemIdentifier: string, metadata: number): string {
    return `/mc/${itemIdentifier.replaceAll(':', '_')}_${metadata}.png`;
}

// Potions and spawn eggs ship one sprite for every damage value, and the game does not colour them
// with one either: it stacks the item model's layers and multiplies each by its own tint. Composing
// the same layers is the only way a metadata-coloured item renders as itself.
export function tintedItemLayers(
    itemIdentifier: string,
    potionColor?: string,
    spawnEggColors?: { base: string; spot: string },
): TintedLayer[] | null {
    const bottle = POTION_BOTTLES[itemIdentifier];
    if (bottle && potionColor) {
        return [{ src: '/mc/potion_overlay.png', tint: potionColor }, { src: bottle }];
    }
    if (spawnEggColors) {
        return [
            { src: '/mc/spawn_egg.png', tint: spawnEggColors.base },
            { src: '/mc/spawn_egg_overlay.png', tint: spawnEggColors.spot },
        ];
    }
    return null;
}
